/** Barramento do useTracker — componentes chamam sem prop drilling. */
let _track = () => {};

const SURFACES = {
  "/": "Login",
  "/home": "Home",
  "/dashboard": "Dashboard",
  "/news": "Novidades",
  "/super-promos": "Super promo",
  "/auctions": "Leilão",
  "/shop": "Shop",
  "/prize-wheel": "Roleta",
  "/points": "Pontos",
  "/register": "Cadastro",
  "/gate": "LP",
};

export function setTracker(fn) {
  _track = typeof fn === "function" ? fn : () => {};
}

export function trackClient(eventType, extra = {}) {
  try {
    _track(eventType, extra);
  } catch {
    /* tracker ainda não montou */
  }
}

export function surfaceFromPage(page) {
  if (!page) return "";
  if (page.startsWith("/auction")) return "Leilão";
  return SURFACES[page] || page;
}

/** Foto + botão + superfície. É o que o card da cliente precisa ler. */
export function trackPiece(eventType, piece = {}) {
  const page = piece.page || (typeof window !== "undefined" ? window.location.pathname : "");
  const image = piece.image_url || piece.url || piece.photo || "";
  trackClient(eventType, {
    page,
    duration_seconds: piece.duration_seconds ?? null,
    metadata: {
      surface: piece.surface || surfaceFromPage(page),
      button: piece.button || null,
      image_url: image || null,
      productId: piece.productId || piece.id || image || null,
      title: piece.title || "",
      brand: piece.brand || "",
      price: piece.price ?? null,
      promoId: piece.promoId || null,
      auctionId: piece.auctionId || null,
      duration_seconds: piece.duration_seconds ?? null,
      photoIndex: piece.photoIndex ?? null,
      photoTotal: piece.photoTotal ?? null,
      addAmount: piece.addAmount ?? null,
      bidAmount: piece.bidAmount ?? null,
      sseAmount: piece.sseAmount ?? null,
      currentPrice: piece.currentPrice ?? null,
      visibility: piece.visibility ?? null,
    },
  });
}
